import React from "react";

export default function onResize(WrappedComponent) {
  return class OnResize extends React.Component {
    constructor(props) {
      super(props);

      this.throttleResize = this.throttleResize.bind(this);

      this.state = {
        width: 0,
        height: 0,
      };
    }

    throttleResize() {
      const documentElement = document.documentElement;
      const body = document.getElementsByTagName("body")[0];
      const width = window.innerWidth || documentElement.clientWidth || body.clientWidth;
      const height =
        window.innerHeight || documentElement.clientHeight || body.clientHeight;

      this.setState({
        width,
        height,
      });
    }

    componentDidMount() {
      window.addEventListener("resize", this.throttleResize);
    }

    componentWillUnmount() {
      window.removeEventListener("resize", this.throttleResize);
    }

    render() {
      return <WrappedComponent {...this.state} {...this.props} />;
    }
  };
}
